export interface SeoReportPathInput {
  slug?: string | null
  categorySlug?: string | null
  subcategorySlug?: string | null
}

export interface SeoReportUrlInput extends SeoReportPathInput {
  baseUrl?: string | null
}

function cleanPathSegment(value: string | null | undefined): string | null {
  if (!value) return null
  const segment = value.trim().replace(/^\/+|\/+$/g, '')
  if (!segment || segment.includes('/')) return null
  return segment
}

export function buildSeoReportPath(input: SeoReportPathInput): string {
  const slug = cleanPathSegment(input.slug)
  if (!slug) return '/reports'

  return `/reports/${slug}`
}

export function buildSeoReportUrl(input: SeoReportUrlInput): string {
  const baseUrl = (input.baseUrl ?? 'https://dupe.com').replace(/\/$/, '')
  return `${baseUrl}${buildSeoReportPath(input)}`
}
